import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from '@nestjs/typeorm';
import { CostingService } from "./costing.service";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { CostSheetController } from "./costing.controller";
import { CostSheetEntity } from "./entity/cost-sheet-entity";
import { CostSheetRepo } from "./repository/costing-repo";
import { MFGCostsEntity } from "./entity/mfg-costs-entity";
import { FreightForwardExpensesEntity } from "./entity/freight-forward-expenses-entity";
import { EnquiriesEntity } from "../enquiries/entites/enquiries";
import { EnquiryProdctsEntity } from "../enquiries/entites/enquiry-products";
import { EnquiryLogEntity } from "../enquiries/entites/enquiry-log";
import { EnquiriesRepository } from "../enquiries/repositories/enquiries.repo";
import { EnquiriesProductsRepository } from "../enquiries/repositories/enquiry-products-repo";
import { DestinationService } from "@gtpl/shared-services/masters";

@Module({
    imports: [
      TypeOrmModule.forFeature([
        // CostSheetEntity,
        CostSheetRepo,
        MFGCostsEntity,
        FreightForwardExpensesEntity,
        EnquiriesEntity,
        EnquiryProdctsEntity,
        EnquiryLogEntity,
      ])
    ],
    controllers: [CostSheetController],
    providers: [ApplicationExceptionHandler,CostingService,LogsService,WhatsappBroadCastService,WhatsAppNotificationService,EnquiriesRepository,EnquiriesProductsRepository,DestinationService],
    exports: [CostingService]
  })
  export class CostSheetModule { }